import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import MyButtonSpinner from 'components/common/my-components/MyButtonSpinner';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { loginColab } from 'redux/loginSlice';

const LoginFormCollab = ({ hasLabel }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPass, setShowPass] = useState(false);
  const { loading } = useSelector(state => state.login);

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      dispatch(loginColab(formData, navigate));
    } catch (error) {
      console.log(e);
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && (
          <Form.Label className="small fw-light">
            <FontAwesomeIcon icon={faEnvelope} /> Email
          </Form.Label>
        )}
        <Form.Control
          placeholder={!hasLabel ? 'Usuario' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && (
          <Form.Label className="small fw-light">
            <FontAwesomeIcon icon={faLock} /> Contraseña
          </Form.Label>
        )}
        <InputGroup>
          <Form.Control
            placeholder={!hasLabel ? 'Contraseña' : ''}
            value={formData.password}
            name="password"
            onChange={handleFieldChange}
            type={showPass ? 'text' : 'password'}
          />
          <InputGroup.Text
            className="px-2"
            onClick={() => setShowPass(!showPass)}
            style={{
              width: '13%',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <FontAwesomeIcon
              icon={showPass ? 'eye-slash' : 'eye'}
              style={{ cursor: 'pointer' }}
            />
          </InputGroup.Text>
        </InputGroup>
      </Form.Group>

      <Form.Group className="w-100 mb-2 d-flex justify-content-center">
        {loading ? (
          <MyButtonSpinner className="w-100 mt-3 mb-3" />
        ) : (
          <IconButton
            type="submit"
            color="primary"
            icon="arrow-right-to-bracket"
            iconAlign="right"
            iconClassName="ms-2"
            className="mt-3 mb-3 w-100"
            disabled={!formData.email || !formData.password}
          >
            <span className="fw-light">Ingresar al panel</span>
          </IconButton>
        )}
      </Form.Group>

      <center>
        <Link className="fs--1 mb-0" to={`/recuperar-contrasena`}>
          ¿Olvidó su contraseña?
        </Link>
      </center>
    </Form>
  );
};

LoginFormCollab.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginFormCollab.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginFormCollab;
